import React from 'react'
import styled from 'styled-components'
import { components, GroupTypeBase, IndicatorProps } from 'react-select'
import { OptionType } from '../../../types/utilities'

interface DivMainProps {
    disabled: boolean
}
export const DivMain = styled.div<DivMainProps>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100%;
    width: 100%;
    border: 1px solid ${({ theme }) => theme['gray-200']};
    background-color: ${({ theme }) => theme['gray-0']};
    transition: 0.3s;
    &:focus-within {
        background-color: ${({ theme }) => theme['blue-200']};
    }
    &:focus {
        background-color: ${({ theme }) => theme['blue-200']};
    }
`

export const Header = styled.div`
    display: flex;
    align-content: center;
    flex-direction: row;
    margin-top: 10px;
    margin-left: 2px;
`

export const Asterisk = styled.span`
    color: ${({ theme }) => theme['red-700']};
    font-size: 13px;
    margin-left: 5px;
`

export const DivIcon = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    overflow: visible;
    cursor: pointer;
    &:hover {
        .inputBoolean_tooltip {
            display: flex;
            visibility: visible;
        }
    }
`

export const Icon = styled.i`
    font-style: normal;
    font-weight: 900;
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme['blue-500']};
    margin-left: 6px;
`

export const Placeholder = (props: never): JSX.Element => {
    return <components.Placeholder {...props} />
}

const CarentIcon = styled.i<{ disabled?: boolean }>`
    color: ${props => (props.disabled === true ? props.theme['gray-400'] : props.theme['blue-500'])};
`
export const DropdownIndicator = (
    props: IndicatorProps<OptionType, boolean, GroupTypeBase<OptionType>>
): JSX.Element => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                {props.selectProps.menuIsOpen ? (
                    <CarentIcon className={'fas fa-caret-up'} />
                ) : (
                    <CarentIcon disabled={props.selectProps.isDisabled} className={'fas fa-caret-down'} />
                )}
            </components.DropdownIndicator>
        )
    )
}

export const Title = styled.label`
    margin-bottom: 3.5px;
    line-height: 16px;
    color: ${({ theme }) => theme['gray-800']};
    font-family: ${({ theme }) => theme['font-semibold']};
    font-size: 13px;
`
